import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import {
  HiOutlineHome,
  HiOutlineSearch,
  HiOutlineFilm,
  HiOutlineCollection,
  HiOutlineUser,
  HiOutlineTrendingUp,
} from 'react-icons/hi';
import './ios-components.css';

/**
 * Bottom Tab Bar estilo iOS
 * Aparece apenas em dispositivos mobile
 */
function BottomTabBar() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const location = useLocation();

  const tabs = [
    { 
      path: '/dashboard',
      icon: HiOutlineHome, 
      label: t('navigation.home'),
      exact: true 
    },
    { 
      path: '/search', 
      icon: HiOutlineSearch, 
      label: t('navigation.search') 
    },
    { 
      path: '/movies', 
      icon: HiOutlineFilm, 
      label: t('navigation.movies') 
    },
    { 
      path: '/series', 
      icon: HiOutlineCollection, 
      label: t('navigation.series') 
    },
    {
      path: '/top10',
      icon: HiOutlineTrendingUp,
      label: 'Top 10'
    },
    {
      path: '/profile',
      icon: HiOutlineUser,
      label: t('navigation.profile')
    },
  ];

  // Não mostra na tela de login/registro
  const isAuthPage = location.pathname === '/login' || 
                     location.pathname === '/register' || 
                     location.pathname === '/verify-email';
  
  if (isAuthPage || !user) return null;

  return (
    <nav className="ios-bottom-tab-bar">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = tab.exact 
          ? location.pathname === tab.path
          : location.pathname.startsWith(tab.path);

        return (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={`ios-tab-item ${isActive ? 'ios-tab-item--active' : ''}`}
            end={tab.exact}
          >
            <div className="ios-tab-item__icon">
              <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
              {isActive && (
                <motion.div
                  layoutId="activeTabIndicator"
                  className="ios-tab-item__indicator"
                  transition={{ 
                    type: 'spring', 
                    stiffness: 500, 
                    damping: 30 
                  }}
                />
              )}
            </div>
            <span className="ios-tab-item__label">{tab.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}

export default BottomTabBar;
